import request from '@/router/axios';

export const getList = (params) => {
    return request({
        url: '/api/produce/device-maintenance/select/page',
        method: 'post',
        params
    })
}
// 查询设备管理列表
export const getDeviceList = (params) => {
    return request({
        url: '/api/produce/base-device-manage/select/page',
        method: 'post',
        params
    })
}
export const getDetail = (id) => {
    return request({
        url: '/api/produce/device-maintenance/select/id',
        method: 'get',
        params: {
            id
        }
    })
}
export const add = (row) => {
    return request({
        url: '/api/produce/device-maintenance/insert',
        method: 'post',
        data: row
    })
}
export const update = (row) => {
    return request({
        url: '/api/produce/device-maintenance/update',
        method: 'post',
        data: row
    })
}

export const remove = (id) => {
    return request({
        url: "/api/produce/device-maintenance/delete/id",
        method: "get",
        params: {
            id
        }
    });
};
